import OrganizationsPage from './OrganizationsPage';

export default OrganizationsPage;
